var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisplacedFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34365 2.40925C6.23445 2.28073 6.05657 2.23351 5.898 2.29173C5.73971 2.34995 5.63427 2.50074 5.63427 2.6695V3.8535C5.63427 4.07538 5.4537 4.25594 5.23182 4.25594C5.00994 4.25594 4.82937 4.07538 4.82937 3.8535V1.01892C4.82937 0.903555 4.78 0.794089 4.69361 0.717624C4.60427 0.638745 4.55195 0.594475 4.55195 0.594475C4.40278 0.468912 4.18438 0.468375 4.0344 0.59367C3.86967 0.731576 0 4.00696 0 7.20723C0 9.57415 1.92585 11.5 4.29277 11.5C6.6597 11.5 8.58555 9.57415 8.58555 7.20723C8.58555 5.42465 7.3664 3.61417 6.34365 2.40925ZM4.34482 10.8285C3.94077 10.8403 3.55576 10.6852 3.23809 10.4351C1.68384 9.21195 3.13775 7.25284 3.89703 6.4085C4.10926 6.17267 4.47763 6.17401 4.68986 6.40984C5.20445 6.98239 6.03671 8.06578 6.03671 9.08532C6.03671 10.0311 5.28387 10.8008 4.34482 10.8285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplacedFire);
export default __webpack_public_path__ + "static/media/displaced-fire.f6435b75d7b68d56b0ad12aa32b37fd4.svg";
export { ForwardRef as ReactComponent };